"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var styled_components_1 = __importDefault(require("styled-components"));
var Sentry = __importStar(require("@sentry/browser"));
var components_1 = require("components");
var Layout_1 = __importDefault(require("./Layout"));
var Store_1 = __importDefault(require("./Store"));
var BYOStrings_1 = __importDefault(require("./BYOStrings"));
if (window.zlurlparams.enableerrorreporting) {
    Sentry.init({ dsn: 'https://2186fbbe69d5478e89f33c64097ff896@sentry-dev.zlthunder.net/8', debug: process.env.NODE_ENV !== 'production', release: process.env.BARD_BUILD_IDENT });
}
var MainPanel = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\ttransform: translate(-50%, -50%);\n\theight: 100%;\n\twidth: 100%;\n\tmax-width: ", "px;\n\tmax-height: ", "px;\n\tmargin: auto 0;\n\ttop: 50%;\n\tleft: 50%;\n\tposition: absolute;\n"], ["\n\ttransform: translate(-50%, -50%);\n\theight: 100%;\n\twidth: 100%;\n\tmax-width: ", "px;\n\tmax-height: ", "px;\n\tmargin: auto 0;\n\ttop: 50%;\n\tleft: 50%;\n\tposition: absolute;\n"])), function (props) { return props.w; }, function (props) { return props.h; });
var BuildYourOwn = /** @class */ (function (_super) {
    __extends(BuildYourOwn, _super);
    function BuildYourOwn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BuildYourOwn.prototype.render = function () {
        var layout = null;
        var sw = window.zlurlparams.sw || 1280;
        if (window.zlurlparams.nostretch) {
            sw = parseInt(sw);
            // intended for debug/demonstration purposes only. +100 and +88 are just to guestimate the extra size beyond the streaming panel.
            layout = (react_1.default.createElement(MainPanel, { w: sw + 100, h: ((sw / 16) * 9) + 88 },
                react_1.default.createElement(Layout_1.default, null)));
        }
        else {
            layout = (react_1.default.createElement(Layout_1.default, null));
        }
        return (react_1.default.createElement(react_redux_1.Provider, { store: Store_1.default },
            react_1.default.createElement(components_1.PageRoot, null,
                react_1.default.createElement(BYOStrings_1.default, null, navigator.documentMode && navigator.documentMode <= 9 ?
                    react_1.default.createElement("div", null, "Internet Explorer 9 or below are unsupported")
                    :
                        layout))));
    };
    return BuildYourOwn;
}(react_1.Component));
exports.default = BuildYourOwn;
var templateObject_1;
//# sourceMappingURL=BuildYourOwn.js.map